/*
 * @Author: your name
 * @Date: 2021-02-19 09:01:15
 * @LastEditTime: 2021-02-19 10:31:35
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \show-m\src\plugins\index.js
 */
import Vue from 'vue';
import VueApis from './apis';
import VueAxios from './axios';
import oss from './oss';

Vue.use(VueApis);
Vue.use(oss);
Vue.use(VueAxios);



// WEBPACK FOOTER //
// ./src/plugins/index.js